export function shortNumberFormat (num) {
    if (num == null || isNaN(num)) return '';

    if (num >= 1e8) return `${Math.floor(num / 1e8)}亿+`;
    if (num >= 1e7) return `${(num / 1e7).toFixed(1)}千万+`;
    if (num >= 1e6) return `${Math.floor(num / 1e4)}万+`;
    if (num >= 1e4) return `${Math.floor(num / 1e4)}万+`;
    if (num >= 1e3) return `${Math.floor(num / 1e3)}千+`;

    return `${num}`;
}
